// AuditTimeline · Lot M2
// Timeline verticale des transitions d'un mandat.

import { statusMeta } from "./StatusPill";
import { ArrowRight, User } from "lucide-react";

const TYPE_LABELS = {
  "mandate.transition.sign":                            "Signature",
  "mandate.transition.mark_ready":                      "Marqué prêt",
  "mandate.transition.start_commercialization":         "Lancement commercialisation",
  "mandate.transition.withdraw_from_commercialization": "Retrait de commercialisation",
  "mandate.transition.close":                           "Clôture sans vente",
};

const fmt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return ""; }
};

export default function AuditTimeline({ events = [], loading = false }) {
  if (loading) {
    return (
      <div className="space-y-3" data-testid="audit-timeline-loading">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-14 animate-pulse rounded-2xl bg-black/[0.03]" />
        ))}
      </div>
    );
  }
  if (!events.length) {
    return (
      <div
        className="rounded-2xl bg-black/[0.02] px-4 py-6 text-center text-[12.5px] text-black/45"
        data-testid="audit-timeline-empty"
      >
        Aucune transition enregistrée pour l&apos;instant.
      </div>
    );
  }

  return (
    <ol className="space-y-0 relative" data-testid="audit-timeline">
      {/* Ligne verticale */}
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-black/[0.08]" />

      {events.map((e, idx) => {
        const fromMeta = statusMeta(e.from_status);
        const toMeta = statusMeta(e.to_status);
        const label = TYPE_LABELS[e.type] || e.type;
        return (
          <li
            key={e.id || idx}
            className="relative pl-8 pb-6 last:pb-0"
            data-testid={`audit-timeline-event-${idx}`}
          >
            <span
              className="absolute left-0 top-[7px] h-[15px] w-[15px] rounded-full border-[3px] border-[#FAFAF7]"
              style={{ background: toMeta.dot }}
            />
            <div className="text-[13.5px] font-medium text-black">
              {label}
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[11.5px] text-black/50">
              <span className="uppercase tracking-[0.12em]">
                {fromMeta.label}
              </span>
              <ArrowRight size={11} className="opacity-50" />
              <span className="uppercase tracking-[0.12em]">
                {toMeta.label}
              </span>
            </div>
            {e.comment && (
              <div className="mt-2 rounded-xl bg-black/[0.03] px-3 py-2 text-[12px] text-black/70">
                {e.comment}
              </div>
            )}
            <div className="mt-2 flex items-center gap-1.5 text-[11px] text-black/40">
              <User size={11} strokeWidth={1.7} />
              <span>{e.actor_name || "—"}</span>
              <span>·</span>
              <time>{fmt(e.at)}</time>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
